import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { BaseStudentListComponent } from '../../../../shared/base-student-list/base-student-list.component';
import { IStudentsListFilters } from '../../../students/students-list-models/students-list-filters.interface';
import {
  ScheduledHeroEventUpdateDto,
  StudentPerformanceDto
} from '@whetstoneeducation/hero-common';
import { AppEventService } from '../../events.service';
import { AppStudentsService } from '../../../students/students.service';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { AppToastManagerService } from '../../../../shared/services/toast-manager.service';
import { AddStudentColumnsEnum } from '../../../custom-rosters/custom-roster-models/add-student-columns.enum';

@Component({
  selector: 'app-add-student-to-scheduled-hero-event-modal',
  templateUrl: './add-student-to-scheduled-hero-event-modal.component.html',
  styleUrls: ['./add-student-to-scheduled-hero-event-modal.component.scss']
})
export class AppAddStudentToScheduledHeroEventModalComponent
  extends BaseStudentListComponent
  implements OnInit, OnDestroy
{
  public isLoading: boolean = true;
  public scheduledHeroEventId: number;
  public search: string;
  public grade: string;
  public filters: IStudentsListFilters;
  public studentsAdded: number[] = [];
  public students: StudentPerformanceDto[] = [];

  constructor(
    public eventsService: AppEventService,
    public studentsService: AppStudentsService,
    public dialogRef: MatDialogRef<AppAddStudentToScheduledHeroEventModalComponent>,
    public toastService: AppToastManagerService,
    @Inject(MAT_DIALOG_DATA)
    public data: {
      scheduledHeroEventId: number;
      onClose: () => Promise<void>;
    }
  ) {
    super(studentsService, toastService);
  }

  async ngOnDestroy() {
    await this.data.onClose();
  }

  async ngOnInit() {
    this.scheduledHeroEventId = this.data.scheduledHeroEventId;
    const currentSchoolId = this.StorageManager.getCurrentSchoolId();
    if (!currentSchoolId) {
      this.toastService.error('Please select a school first');
      this.dialogRef.close();
      this.isLoading = false;

      return;
    }
    await this.loadFiltersAndStudents({
      scheduledHeroEventId: this.scheduledHeroEventId
    });
    this.isLoading = false;
  }

  async handleClose() {
    await this.data.onClose();
    this.dialogRef.close();
  }

  public get displayedColumns() {
    return Object.values(AddStudentColumnsEnum);
  }

  public columnValues = {
    [AddStudentColumnsEnum.STUDENT_NAME]: ['Student Name'],
    [AddStudentColumnsEnum.STUDENT_ID]: ['Student ID'],
    [AddStudentColumnsEnum.GRADE]: ['Grade'],
    [AddStudentColumnsEnum.ACTION]: ['Add']
  };

  async addStudent(studentId: number) {
    this.isLoading = true;
    try {
      await this.eventsService.updateScheduledHeroEvent(
        this.scheduledHeroEventId,
        new ScheduledHeroEventUpdateDto({
          addStudentId: studentId
        })
      );
      this.studentsAdded.push(studentId);
      await this.updateStudentsList(this.filters);
    } catch (error) {
      this.toastService.error('Failed to add student');
    }
    this.isLoading = false;
  }

  protected readonly columns = AddStudentColumnsEnum;
}
